import { CurrentDeliveryStatsDto, KnownDeliveryState } from '@groundfloor-platform/mgmt-service-g-sdk';
import { createPath, Paths, ProjectPathParams } from '../../../../../app/router/app.router';
import { StatusCancelled } from '../../../../../ui/components/pure/icons/StatusCancelled.icon';
import { StatusCollected } from '../../../../../ui/components/pure/icons/StatusCollected.icon';
import { StatusDelivered } from '../../../../../ui/components/pure/icons/StatusDelivered.icon';
import { StatusInProgress } from '../../../../../ui/components/pure/icons/StatusInProgess.icon';
import { StatusOverdue } from '../../../../../ui/components/pure/icons/StatusOverdue.icon';
import { StatusRetrievalRequired } from '../../../../../ui/components/pure/icons/StatusRetrievalRequired.icon';
import { StatusRetrieved } from '../../../../../ui/components/pure/icons/StatusRetrieved.icon';
import { SVGIconComponent } from '../../../../../ui/components/pure/icons/types';
import { useDashboardStats } from '../../../hooks/useDashboardStats';
import { StatusCountCardLarge } from '../status-count-card-large/status-count-card-large.component';
import { StatusCountCardSmall } from '../status-count-card-small/status-count-card-small.component';

export function DeliveryStatusCountCard({
  state,
  params,
  size,
  showSubtitle = true
}: {
  state: Exclude<KnownDeliveryState, KnownDeliveryState.Abandoned>;
  params: ProjectPathParams<Paths.dashboard>;
  size: 'large' | 'small';
  showSubtitle?: boolean;
}) {
  const { currentStats } = useDashboardStats(params.projectID);

  const linkBase = createPath(Paths.deliveries, { projectID: params.shortcode || params.projectID });
  const linkFull = `${linkBase}?state=${state}`;

  const Component = size === 'small' ? StatusCountCardSmall : StatusCountCardLarge;

  return (
    <Component
      status={state}
      count={currentStats.currentDeliveryStats.data?.states[stateCountKeyMap[state]]}
      isLoading={currentStats.currentMergedStats.isLoading}
      link={linkFull}
      Icon={stateIconMap[state]}
      showSubtitle={showSubtitle}
    />
  );
}

const stateCountKeyMap: Record<KnownDeliveryState, keyof CurrentDeliveryStatsDto['states']> = {
  'in-progress': 'inProgress',
  cancelled: 'cancelled',
  collected: 'collected',
  delivered: 'delivered',
  'delivered-offline': 'deliveredOffline',
  overdue: 'overdue',
  retrieved: 'retrieved',
  abandoned: 'abandoned',
  'retrieval-required': 'retrievalRequired'
};

const stateIconMap: Omit<Record<KnownDeliveryState, SVGIconComponent>, 'abandoned'> = {
  'in-progress': StatusInProgress,
  cancelled: StatusCancelled,
  collected: StatusCollected,
  delivered: StatusDelivered,
  'delivered-offline': StatusInProgress,
  overdue: StatusOverdue,
  retrieved: StatusRetrieved,
  'retrieval-required': StatusRetrievalRequired
};
